import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown"]
  static values = {
    open: { type: Boolean, default: false }
  }

  connect() {
    this.closeOnClickOutside = this.closeOnClickOutside.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnClickOutside)
  }

  toggle(event) {
    event.stopPropagation()
    this.openValue = !this.openValue
  }

  openValueChanged() {
    if (this.openValue) {
      this.show()
    } else {
      this.hide()
    }
  }

  show() {
    this.dropdownTarget.classList.add("is-open")
    document.addEventListener("click", this.closeOnClickOutside)
  }

  hide() {
    this.dropdownTarget.classList.remove("is-open")
    document.removeEventListener("click", this.closeOnClickOutside)
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.openValue = false
    }
  }

  select(event) {
    // Form submission is handled by the browser
    // Close dropdown immediately for better UX
    this.openValue = false
  }
}
